const state = {
  copied_playlistitem_daytime_restrictions: [],
  copied_playlistitem_date_restrictions: [],
  copied_device_daytime_restrictions: [],
  copied_device_date_restrictions: [],
  copied_media_tags: [],
  copied_device_tags: [],
  copied_local_playitems: [],
  copied_player_exceptions: {},
  copied_play_properties: {},
  copied_synchro_listener: ''
}

export default state



//////////////////
// WEBPACK FOOTER
// ./state/clipboard/clipboard.state.js
// module id = null
// module chunks = 